// SPDX-License-Identifier: Apache-2.0
import HeaderView from './HeaderView';

export default HeaderView;
